import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
  
} from "@mui/material";
import React from "react";
import "./ProductCard.css";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { Grid } from "@mui/material";

// const obj =
// {
//   "name":"Tan Leatherette Weekender Duffle",
//   "category":"Fashion",
//   "cost":150,
//   "rating":4,
//   "image":"https://crio-directus-assets.s3.ap-south-1.amazonaws.com/ff071a1c-1099-48f9-9b03-f858ccc53832.png",
//   "_id":"PmInA797xJhMIPti"
//   }



const ProductCard = ({ product, handleAddToCart }) => {
  return (
    <Card className="card">
      <CardMedia component="img" image={product.image} alt={product.name}/>
      <CardContent>
        <Typography>
          {product.name}
        </Typography>        
        
        <Typography>
          ${product.cost}
        </Typography>
        </CardContent> 
        <Rating name="rateProduct" defaultValue={product.rating} precision={product.precision} readOnly/>      
        <CardActions>
        <Button onClick={handleAddToCart} fullWidth variant="contained" startIcon={<AddShoppingCartIcon/>}>
         ADD TO CART
        </Button>
        </CardActions>    
        </Card>   
   
  );
};

export default ProductCard;
